module.exports = __webpack_public_path__ + "img/22.f827c92c.gif";